import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'

import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import { useAuth } from '../modules/auth'
import { AppViewProvider } from '../modules/core/app/AppViewContext'

const SetscoRoutes = () => {

  const { currentUser, hasRole } = useAuth();

  const ProductTypesPage = lazy(() => import('../modules/setsco/producttypes/ProductTypesPage'))
  const UsersPage = lazy(() => import('../modules/setsco/users/UsersPage'))
  const PricesPage = lazy(() => import('../modules/setsco/prices/PricesPage'))
  const ClientManagersPage = lazy(() => import('../modules/setsco/clientmanagers/ClientManagersPage'))

  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const ApplicationsPage = lazy(() => import('../modules/setsco/applications/ApplicationsPage'))
  const ApplicationReviewPage = lazy(() => import('../modules/setsco/workflow/ApplicationReviewPage'))
  const EditApplicationPage = lazy(() => import('../modules/setsco/applications/edit-application/EditApplicationPage'))

  const CertificatesPage = lazy(() => import('../modules/setsco/certificates/CertificatesPage'))
  const CertificateViewPage = lazy(() => import('../modules/setsco/certificates/certificate-view/CertificateViewPage'))

  const ReportsModulePage = lazy(() => import('../modules/setsco/reports/ReportsModulePage'))

  const CompaniesPage = lazy(() => import('../modules/setsco/companies/CompaniesPage'))
  const CompanyViewWrapper = lazy(() => import('../modules/setsco/companies/company-view/CompanyViewWrapper'))

  const DOCLabelModulePage = lazy(() => import('../modules/setsco/doclabel/DOCLabelModulePage'))

  const SystemConfigPage = lazy( () => import('../modules/setsco/settings/SystemConfigPage'))

  const MultipleFileUploaderPage = lazy( () => import('../components/utilities/multiple-file/MultipleFileUploaderPage'))

  return (
  <AppViewProvider>
  <Routes>
    <Route element={<MasterLayout />}>
      {/* Redirect to Dashboard after success login/registration */}
      {currentUser && currentUser.role === 'System Admin' ? (
      <>
      <Route path='/setsco/auth/*' element={<Navigate to='/setsco/user-management' />} />
      <Route
        path='/setsco/producttype-management/*'
        element={
          <SuspensedView>
            <ProductTypesPage />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/company-management/*'
        element={
          <SuspensedView>
            <CompaniesPage />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/view-company/:id/*'
        element={
          <SuspensedView>
            <CompanyViewWrapper />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/clientmanager-management/*'
        element={
          <SuspensedView>
            <ClientManagersPage />
          </SuspensedView>
        }
      />
      </>
      ) : (
      <>
      <Route path='/setsco/auth/*' element={<Navigate to='/setsco/application-management' />} />
      <Route
        path='/setsco/application-management/*'
        element={
          <SuspensedView>
            <ApplicationsPage />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/review-application/:appid/*'
        element={
          <SuspensedView>
            <ApplicationReviewPage />
          </SuspensedView>
        }
      />



      { hasRole(['CAMS Admin','CAMS Program Manager','CAMS Inspector','CAMS Second Reviewer']) &&
      <>
      <Route
        path='/setsco/certificate-management/*'
        element={
          <SuspensedView>
            <CertificatesPage />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/view-certificate/:cocid'
        element={
          <SuspensedView>
            <CertificateViewPage />
          </SuspensedView>
        }
      />
      </>
      }

      { hasRole('CAMS Admin') &&
      <>
      <Route
        path='/setsco/reports/*'
        element={
          <SuspensedView>
            <ReportsModulePage />
          </SuspensedView>
        }
      />

      <Route
        path='/setsco/edit-application/:appid/'
        element={
          <SuspensedView>
            <EditApplicationPage />
          </SuspensedView>
        }
      />
      </>
      }

      { hasRole(['User Admin','Super Admin']) &&
      <>
      <Route
        path='/setsco/user-management/*'
        element={
          <SuspensedView>
            <UsersPage />
          </SuspensedView>
        }
      />
      </>
      }
      { hasRole(['Super Admin']) &&
      <>
      <Route
        path='/setsco/prices-settings/*'
        element={
          <SuspensedView>
            <PricesPage />
          </SuspensedView>
        }
      />
      </>
      }
      { hasRole(['CAMS Admin','System Admin']) &&
      <>
      <Route
        path='/setsco/company-management/*'
        element={
          <SuspensedView>
            <CompaniesPage />
          </SuspensedView>
        }
      />

      <Route
        path='/setsco/view-company/:id/*'
        element={
          <SuspensedView>
            <CompanyViewWrapper />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/clientmanager-management/*'
        element={
          <SuspensedView>
            <ClientManagersPage />
          </SuspensedView>
        }
      />
      <Route
        path='/setsco/system-settings/configuration'
        element={
          <SuspensedView>
            <SystemConfigPage />
          </SuspensedView>
        }
      />

      </>
      }

      { hasRole(['CAMS Admin','CAMS Program Manager','System Admin']) &&
      <Route
        path='/setsco/producttype-management/*'
        element={
          <SuspensedView>
            <ProductTypesPage />
          </SuspensedView>
        }
      />
      }

      <Route
        path='/user/account/*'
        element={
          <SuspensedView>
            <AccountPage />
          </SuspensedView>
        }
      />

      <Route
        path='/setsco/file-uploader'
        element={
          <SuspensedView>
            <MultipleFileUploaderPage />
          </SuspensedView>
        }
      />

      </>
      )}

      { hasRole(['DLM Admin','System Admin','DLM Program Manager','DLM Inspector', 'CAMS Quotation Admin']) &&
      <>
      <Route
        path='/setsco/doclabel-management/*'
        element={
          <SuspensedView>
            <DOCLabelModulePage />
          </SuspensedView>
        }
      />
      </>
      }
      {/* Pages */}

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Route>
  </Routes>
  </AppViewProvider>

  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {SetscoRoutes}
